// initial state
import * as base from './base.js'
const baseName = '/admin/homePage'

const getWorkEvaluateFacility = baseName + '/getWorkEvaluateFacility'
const homeGetWork = baseName + '/getWork'
const homeKnowledge = baseName + '/knowledge'

const obj = base.setBaseUrl('', baseName)

const a = Object.assign(obj, { getWorkEvaluateFacility, homeGetWork, homeKnowledge })
export default a
